import requests from "./base";

const Charts = {
  leads: () => requests.get(`chart/lead-page/`),
  dashboard: () => requests.get(`chart/dashboard/`),
};

export default Charts;
